"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressValidationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@dzambalaorg/constants");
exports.addressValidationSchema = (0, yup_1.object)().shape({
    addressLine1: (0, yup_1.string)().required("form.validations.valueMissing"),
    addressLine2: (0, yup_1.string)(),
    city: (0, yup_1.string)().required("form.validations.valueMissing"),
    country: (0, yup_1.string)().oneOf(Object.values(constants_1.EnabledCountries)).required("form.validations.valueMissing"),
    state: (0, yup_1.string)(),
    zip: (0, yup_1.string)().required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map